import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/ar-images/icon/xz-icon.png'
import _imports_1 from '@/assets/images/ar-images/icon/cjsy-icon.png'


const _hoisted_1 = { class: "ar-wechat" }
const _hoisted_2 = { class: "yxhd" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content-title" }
const _hoisted_6 = { class: "jyhpx" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "content-title" }
const _hoisted_10 = { class: "lyyl" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "content-title" }
const _hoisted_14 = { class: "dhfw" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "content" }
const _hoisted_17 = { class: "content-title" }
const _hoisted_18 = { class: "xcxgn" }

import { modelTypes } from '@/config';
import SubTitle from '@/components/SubTitle.vue';
import ExampleIntroduction from '@/components/common/ExampleIntroduction.vue'
import { exampleDatas } from '@/config/index'
import StepProcess from '@/components/common/StepProcess.vue';
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArWechat',
  setup(__props) {

const handleEvent = () => {
  let contactUsTop: any = store.state.contactUsTop;
  contactUsTop = {
    bottom: 457 + 'rem'
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SubTitle, { "title-text": "应用场景" }),
    _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "secondary-title",
      style: {"margin-top":"46rem"}
    }, "AR营销互动", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)['wechart-ar'], (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.header,
            style: _normalizeStyle({marginBottom: index > 2 ? '0' : '46rem'})
          }, [
            _createElementVNode("img", {
              src: item.image,
              alt: ""
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.remarkList[0]), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.header), 1)
          ], 4))
        }), 128))
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "secondary-title" }, "AR教育和培训", -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("main", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)['wechart-education'], (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.header
          }, [
            _createElementVNode("img", {
              src: item.image,
              alt: ""
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.remarkList[0]), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.header), 1)
          ]))
        }), 128))
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "secondary-title" }, "AR旅游娱乐", -1)),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("main", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)['wechart-entertainment'], (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.header
          }, [
            _createElementVNode("img", {
              src: item.image,
              alt: ""
            }, null, 8, _hoisted_11),
            _createElementVNode("div", _hoisted_12, _toDisplayString(item.remarkList[0]), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(item.header), 1)
          ]))
        }), 128))
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "secondary-title" }, "AR导航服务", -1)),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("main", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)['wechart-navigation'], (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.header
          }, [
            _createElementVNode("img", {
              src: item.image,
              alt: ""
            }, null, 8, _hoisted_15),
            _createElementVNode("div", _hoisted_16, _toDisplayString(item.remarkList[0]), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(item.header), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(SubTitle, {
        "mode-class": "black-style",
        "title-text": "AR小程序功能特性"
      }),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"xcxgn-content\" data-v-124ecd2e><div class=\"left\" data-v-124ecd2e><header data-v-124ecd2e><img src=\"" + _imports_0 + "\" class=\"l-iamge\" alt=\"\" data-v-124ecd2e><div class=\"r-head\" data-v-124ecd2e>无需下载APP</div></header><div class=\"line\" data-v-124ecd2e>用户只需打开微信或其他支持小程序的平台，即可轻松体验AR技术所带来的乐趣。</div></div><div class=\"right\" data-v-124ecd2e><header data-v-124ecd2e><img src=\"" + _imports_1 + "\" class=\"l-iamge\" alt=\"\" data-v-124ecd2e><div class=\"r-head\" data-v-124ecd2e>全场景适用</div></header><div class=\"line\" data-v-124ecd2e>快速触发、全场景适用，AR小程序正在各个领域展现出强大的应用潜力和市场价值。</div></div></div>", 1))
    ]),
    _createVNode(ExampleIntroduction, {
      exampleData: _unref(exampleDatas).arWechat
    }, null, 8, ["exampleData"]),
    _createVNode(StepProcess, {
      "step-title": ['沉浸式体验', '一站式部署流程'],
      "step-type": "step1"
    }),
    _createElementVNode("div", { class: "counselling-btn" }, [
      _createElementVNode("div", {
        class: "btn",
        onClick: handleEvent
      }, "合作咨询")
    ])
  ]))
}
}

})